import { useEffect, useState } from "react";
import DataTable from "../../component/DataTable";
import { Link } from "react-router-dom";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints"; 
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";

const newsDeleteEndpoint = ApiEndpoints.news.newsDelete;
const newsListEndpoint = ApiEndpoints.news.newsList;
const newsEditPath = "edit-news";
const tableHeader = ["Date","Title","Slug"];
const tbody = ["date","title","slug"];

export default function NewsListing() {

  const [data, setData] = useState([]);

  const dataFetch = async () => {
    try {
      const response = await ApiRequest("GET", newsListEndpoint);
      const result = response.medias;
      setData(result);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => { 
    dataFetch();
  }, []);

  const handleDelete = async (news_id) => {
    const payload = { news_id };
    try {
      const response = await ApiRequest("POST", newsDeleteEndpoint, payload);
      toast.success(response.message)
      dataFetch();
    } catch (error) {
      console.error(error);
    }
  };

  const pagename = {
    name: 'News Management',
    user: 'Admin',
    innerpage: 'News Management / News'
  }

  return (
    <>
    <AdminHeader pagename={pagename}/>

    <div className="add-btn-section">
      <Link className="admin-add-btn" to="/add-news">Add +</Link>
      <DataTable
        data={data}
        tableHeader={tableHeader}
        tbody={tbody}
        editPath={newsEditPath}
        // onDelete={handleDelete}
      />
    </div>
    </>
  )
}
